'use strict';

module.exports = require('./lib/');



/*****************
 ** WEBPACK FOOTER
 ** ./~/remarkable/index.js
 ** module id = 970
 ** module chunks = 1
 **/